import { useAppSelector } from "../ReduxToolkit/Hooks";

export const useModalSelector = () => {
  const { isOpen, modalType, selectedId } = useAppSelector(
    ({ employeeProfileDetailModalSlice }) => employeeProfileDetailModalSlice
  );
  return { isOpen, modalType, selectedId };
};
